/* eslint-disable react-refresh/only-export-components */

import { Typography } from "antd";
import { memo, type ReactNode } from "react";

const { Title, Text } = Typography;

interface CustomHeadingClassNames {
  title?: string;
  description?: string;
  container?: string;
  wrapper?: string;
}

interface CustomHeadingProps {
  title?: ReactNode;
  description?: ReactNode;
  children?: ReactNode;
  classNames?: CustomHeadingClassNames;
}

function CustomHeading({
  title = "",
  description = "",
  children,
  classNames = {
    title: "",
    description: "",
    container: "",
    wrapper: "",
  },
}: CustomHeadingProps) {
  return (
    <div className={`flex flex-col gap-2 ${classNames.container || ""}`}>
      <div
        className={`flex justify-between items-start flex-wrap gap-3 ${
          classNames.wrapper || ""
        }`}
      >
        <div className="flex-1">
          <Title
            className={`antd-design-typography-title ${classNames.title || ""}`}
          >
            {title}
          </Title>

          {description && (
            <Text type="secondary" className={classNames.description || ""}>
              {description}
            </Text>
          )}
        </div>

        {children && <div>{children}</div>}
      </div>
    </div>
  );
}

export default memo(CustomHeading);
